import getScriptUrl from "../../utils/helper/envConfig"; 
const scriptUrl = getScriptUrl();

export const snippetForEnv = (oneTrustKey) => {
  const oneTrustSDK = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
  return `
    window.OptanonWrapper = function() { };
    (function() {
      var otScript = document.createElement('script');
       otScript.async = true;
      otScript.src = '${oneTrustSDK}';
      otScript.type = 'text/javascript';
      otScript.charset = 'UTF-8';
      otScript.setAttribute('data-domain-script', '${oneTrustKey}');
      a=document.getElementsByTagName('script')[0];a.parentNode.insertBefore(otScript,a)
    })();
  `;
};

export const oneTrustScript = () => {
  return snippetForEnv(scriptUrl.REACT_APP_ONE_TRUST_KEY);
}